module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/link-179dde462bb4340fd349854b716d7245.svg";